import React from 'react';
import ErrorPopup from '../ErrorPopup/ErrorPopup';
import { AlertContent, Types } from '../ContentMessages';
import PropTypes from 'prop-types';

const AlertBox = function(props) {
    return(
        <ErrorPopup
            show={props.show}
            closable={props.closable}
            className={props.className}
            primaryCtaLabel={
            <AlertContent
                page={props.field_page}
                type={[Types.PAGE_ALERTS]}
                keyProperty={props.name}
                property={"field_alert_button1_text"}
                html={true}
                defaultMessage={props.defaultContent && props.defaultContent['continue'] ? props.defaultContent.continue: ''}
            />
            }
            primaryCta={ props.primaryBtnEvent ? props.primaryBtnEvent.bind(this): null}
            secondaryCtaLabel={
                <AlertContent
                    page={props.field_page}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={props.name}
                    property={"field_alert_button2_text"}
                    html={true}
                    defaultMessage={props.defaultContent && props.defaultContent['cancel'] ? props.defaultContent.cancel: ''}
                />            
            }
            secondaryCta={ props.secondaryBtnEvent ? props.secondaryBtnEvent.bind(this): null }
            title={
                <AlertContent
                    page={props.field_page}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={props.name}
                    property={"field_header"}
                    html={true}
                    defaultMessage={props.defaultContent && props.defaultContent['heading'] ? props.defaultContent.heading: ''}
                />            
            }>
                <AlertContent
                    page={props.field_page}
                    type={[Types.PAGE_ALERTS]}
                    keyProperty={props.name}
                    property={"field_description"}
                    html={true}
                    defaultMessage={props.defaultContent && props.defaultContent['line1'] ? props.defaultContent.line1: ''}
                />            
      </ErrorPopup>
    )
}

AlertBox.propTypes = {
 show: PropTypes.bool.isRequired,
 closable: PropTypes.bool,
 className: PropTypes.string,
 field_page: PropTypes.string,
 name: PropTypes.string,
 primaryBtnEvent: PropTypes.func,
 defaultContent: PropTypes.shape({
    heading: PropTypes.string,
    line1: PropTypes.string,
    continue: PropTypes.string,
    cancel: PropTypes.string
 })
}

export default AlertBox;